import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { contractorPayrollBatchesActions, runningCPActions } from './contractor-payroll.actions'
import { catchError, map, of, switchMap } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { ContractorPayrollService } from '../../services/contractor-payroll.service'

// Load all payroll batches
export const loadPayrollBatches$ = createEffect(
  (
    actions$ = inject(Actions),
    payrollService = inject(ContractorPayrollService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(contractorPayrollBatchesActions.loadBatches),
      switchMap(({ belongsTo, payoutFrequency, payPeriodStart, payPeriodEnd }) =>
        payrollService.loadBatches(belongsTo, payoutFrequency, payPeriodStart, payPeriodEnd).pipe(
          map(payrollBatches =>
            contractorPayrollBatchesActions.loadBatchesSuccess({ payrollBatches })
          ),
          catchError(error => {
            toastr.error(error.error.message)
            return of(contractorPayrollBatchesActions.loadBatchesFailure({ error: error.message }))
          })
        )
      )
    ),
  { functional: true }
)

// Load Running Payroll batch
export const loadRunningPayroll$ = createEffect(
  (
    actions$ = inject(Actions),
    payrollService = inject(ContractorPayrollService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(runningCPActions.loadRunningPayroll),
      switchMap(({ payPeriodStart, payPeriodEnd, belongsTo, payoutFrequency }) =>
        payrollService
          .loadRunningPayrollBatch(payPeriodStart, payPeriodEnd, belongsTo, payoutFrequency)
          .pipe(
            map(runningPayrollBatch =>
              runningCPActions.loadRunningPayrollSuccess({ updatedBatch: runningPayrollBatch })
            ),
            catchError(error => {
              toastr.error(error.error.message)
              return of(runningCPActions.loadRunningPayrollFailure({ error: error.message }))
            })
          )
      )
    ),
  {
    functional: true
  }
)

//// Load previous salaries
//export const loadPreviousSalaries$ = createEffect(
//  (
//    actions$ = inject(Actions),
//    payrollService = inject(PayrollService),
//    toastr = inject(ToastrService)
//  ) =>
//    actions$.pipe(
//      ofType(runningCPActions.loadPreviousSalaries),
//      switchMap(({ requests }) =>
//        payrollService.loadPreviousSalaries(requests).pipe(
//          map(previousSalaries =>
//            runningCPActions.loadPreviousSalariesSuccess({ previousSalaries })
//          ),
//          catchError(error => {
//            toastr.error(error.error.message)
//            return of(runningCPActions.loadPreviousSalariesFailure({ error: error.message }))
//          })
//        )
//      )
//    ),
//  { functional: true }
//)

//// Load arrear lop days
//export const loadArrearLopDays$ = createEffect(
//  (
//    actions$ = inject(Actions),
//    payrollService = inject(PayrollService),
//    toastr = inject(ToastrService)
//  ) =>
//    actions$.pipe(
//      ofType(runningCPActions.loadArrearLopDays),
//      switchMap(({ requests }) =>
//        payrollService.loadArrearLopDays(requests).pipe(
//          map(arrearLopDays => runningCPActions.loadArrearLopDaysSuccess({ arrearLopDays })),
//          catchError(error => {
//            toastr.error(error.error.message)
//            return of(runningCPActions.loadArrearLopDaysFailure({ error: error.message }))
//          })
//        )
//      )
//    ),
//  { functional: true }
//)

////Load Batch TDS Preview
//export const loadBatchTdsPreview$ = createEffect(
//  (
//    actions$ = inject(Actions),
//    payrollService = inject(PayrollService),
//    toastr = inject(ToastrService)
//  ) =>
//    actions$.pipe(
//      ofType(tdsCalculationActions.loadBatchTdsPreview),
//      switchMap(({ payload }) =>
//        payrollService.loadBatchTdsPreview(payload).pipe(
//          map(tdsResults => tdsCalculationActions.loadBatchTdsPreviewSuccess(tdsResults)),
//          catchError(error => {
//            toastr.error(error.error.message)
//            return of(tdsCalculationActions.loadBatchTdsPreviewFailure({ error: error.message }))
//          })
//        )
//      )
//    ),
//  { functional: true }
//)

////Load TDS Preview
//export const loadTdsPreview$ = createEffect(
//  (
//    actions$ = inject(Actions),
//    payrollService = inject(PayrollService),
//    toastr = inject(ToastrService)
//  ) =>
//    actions$.pipe(
//      ofType(tdsCalculationActions.loadTdsPreview),
//      switchMap(({ payload }) =>
//        payrollService.loadTdsPreview(payload).pipe(
//          map(tdsResult => tdsCalculationActions.loadTdsPreviewSuccess(tdsResult)),
//          catchError(error => {
//            toastr.error(error.error.message)
//            return of(tdsCalculationActions.loadTdsPreviewFailure({ error: error.message }))
//          })
//        )
//      )
//    ),
//  { functional: true }
//)

// Save Running Payroll Batch draft
export const saveRunningCPBatch$ = createEffect(
  (
    actions$ = inject(Actions),
    payrollService = inject(ContractorPayrollService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(runningCPActions.saveRunningCPBatch),
      switchMap(({ batchData }) =>
        payrollService.upsertRunningPayrollBatch(batchData).pipe(
          map(batchData => runningCPActions.saveRunningCPBatchSuccess({ batchData })),
          catchError(error => {
            toastr.error(error.error.message)
            return of(runningCPActions.saveRunningCPBatchFailure({ error: error.message }))
          })
        )
      )
    ),
  { functional: true }
)

// Update the running payroll status
export const updateRunningPayrollStatus$ = createEffect(
  (
    actions$ = inject(Actions),
    payrollService = inject(ContractorPayrollService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(runningCPActions.updateRunningPayrollStatus),
      switchMap(({ id, status, payrollIds }) => {
        return payrollService.updatePayrollStatus({ id, status, payrollIds }).pipe(
          map(batchData => {
            toastr.success('Contractor Payroll Run Successful!')
            return runningCPActions.updateRunningPayrollStatusSuccess({ batchData })
          }),
          catchError(error => {
            toastr.error(error.error.message)
            return of(runningCPActions.updateRunningPayrollStatusFailure({ error: error.message }))
          })
        )
      })
    ),
  { functional: true }
)

//Finalize Payroll Batch
export const finalizePayrollBatch$ = createEffect(
  (
    actions$ = inject(Actions),
    payrollService = inject(ContractorPayrollService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(contractorPayrollBatchesActions.finalizePayroll),
      switchMap(({ batchId, dateOfPayment, modeOfPayment, paidBy }) =>
        payrollService.finalizePayrollBatch(batchId, dateOfPayment, modeOfPayment, paidBy).pipe(
          map(batchData => {
            toastr.success('Contractor Payroll batch finalized successfully')
            return contractorPayrollBatchesActions.finalizePayrollSuccess({ batch: batchData })
          }),
          catchError(error => {
            toastr.error(error.error.message)
            return of(
              contractorPayrollBatchesActions.finalizePayrollFailure({ error: error.message })
            )
          })
        )
      )
    ),
  { functional: true }
)

// Delete the payroll batch
export const deletePayrollBatch$ = createEffect(
  (
    actions$ = inject(Actions),
    payrollService = inject(ContractorPayrollService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(contractorPayrollBatchesActions.deletePayrollBatch),
      switchMap(({ id }) =>
        payrollService.deletePayrollBatch(id).pipe(
          map(({ id }) => {
            toastr.success('Contractor Payroll batch deleted successfully')
            return contractorPayrollBatchesActions.deletePayrollBatchSuccess({ id })
          }),
          catchError(error => {
            toastr.error(error.error.message)
            return of(
              contractorPayrollBatchesActions.deletePayrollBatchFailure({ error: error.message })
            )
          })
        )
      )
    ),
  { functional: true }
)

//// Load a single user payroll data
//export const loadUserPayrollData$ = createEffect(
//  (
//    actions$ = inject(Actions),
//    payrollService$ = inject(PayrollService),
//    toastr = inject(ToastrService)
//  ) =>
//    actions$.pipe(
//      ofType(userPayrollActions.loadUserPayroll),
//      switchMap(({ payPeriodStart, payPeriodEnd, employeeId }) =>
//        payrollService$.getUserPayrollData(payPeriodStart, payPeriodEnd, employeeId).pipe(
//          map(payroll => userPayrollActions.loadUserPayrollSuccess({ payroll })),
//          catchError(error => {
//            toastr.error(error.error.message)
//            return of(userPayrollActions.loadUserPayrollFailure({ error: error.message }))
//          })
//        )
//      )
//    ),
//  { functional: true }
//)

//// Load the latest user payroll date
//export const loadLatestUserPayrollDate$ = createEffect(
//  (
//    actions$ = inject(Actions),
//    payrollService$ = inject(PayrollService),
//    router = inject(Router),
//    toastr = inject(ToastrService)
//  ) =>
//    actions$.pipe(
//      ofType(userPayrollActions.loadLatestUserPayrollDate),
//      switchMap(({ employeeId }) =>
//        payrollService$.getLatestUserPayrollDate(employeeId).pipe(
//          map(latestPayrollDate =>
//            userPayrollActions.loadLatestUserPayrollDateSuccess(latestPayrollDate)
//          ),
//          catchError(error => {
//            toastr.error(error.error.message)
//            router.navigate([eps.hrm.employeePath, employeeId])
//            return of(userPayrollActions.loadLatestUserPayrollDateFailure({ error: error.message }))
//          })
//        )
//      )
//    ),
//  { functional: true }
//)

////Load Payroll Summary
//const loadPayrollSummary$ = createEffect(
//  (
//    actions$ = inject(Actions),
//    payrollSummaryService = inject(PayrollSummaryService),
//    toastr = inject(ToastrService)
//  ) =>
//    actions$.pipe(
//      ofType(payrollSummaryActions.loadSummary),
//      switchMap(({ employeeId, financialYear, joiningDate }) =>
//        payrollSummaryService.getPayrollSummary(employeeId, financialYear, joiningDate).pipe(
//          map(summary => payrollSummaryActions.loadSummarySuccess({ summary })),
//          catchError(error => {
//            toastr.error(error.error.message)
//            return of(payrollSummaryActions.loadSummaryFailure({ error: error.message }))
//          })
//        )
//      )
//    ),
//  { functional: true }
//)

export const contractorPayrollEffects = {
  loadPayrollBatches$,
  loadRunningPayroll$,
  saveRunningCPBatch$,
  updateRunningPayrollStatus$,
  finalizePayrollBatch$,
  deletePayrollBatch$
}
